<mat-form-field appearance="outline" [floatLabel]="floatLabel">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>
    <input
        #input
        matInput
        [placeholder]="placeholder"
        autocomplete="nothing"
        [formControl]="aumFormControl"
        [type]="hide ? 'password' : 'text'"
    />
    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-icon
        matSuffix
        class="icon"
        (click)="hide = !hide"
        svgIcon="{{hide ? 'aumico-pattern-icon-view-off' :
  'aumico-pattern-icon-view-on'}}"
    ></mat-icon>
    <mat-error *ngIf="aumFormControl!=null && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
